import { Card, Heading } from '@chakra-ui/react';
import { useLocation } from 'react-router';
import Loading from '@components/Loading';

import useGetRoles from './useGetRoles';
import List from './component/List';

const Roles = () => {
  const { state } = useLocation();
  
  const { loading, rolesList, userRoles } = useGetRoles();

  if (loading) return <Loading />;

  return (  
    <Card.Root
      size="sm"
      variant="subtle"
      p={4}
    >
      <Heading size="lg" mb={8} fontWeight={400}>
        Permissões do usuário
        {' '}
        {state?.userName && (
          <b>
            {state.userName}
          </b>
        )}
      </Heading>
      <List
        rolesList={rolesList}
        userRoles={userRoles}
      />
    </Card.Root>
  );
};

export default Roles;
